import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../../prop-types';
import PaymentModuleStore from '../../../store/PaymentModuleStore';
import CountryStore from '../../../store/CountryStore';
import KlarnaPromotionWidget from '../../../integrations/klarna/KlarnaPromotionWidget';
import AccountStore from '../../../store/AccountStore';
import RequestState from '../../../types/RequestState';
import PropTypes from 'prop-types';
import PaymentWidgetType from '../../../types/PaymentWidgetType';

const MAX_IMAGE_HEIGHT = 35;
const IMAGE_ASPECT_RATIO = 20 / 11;

@observer
export class FooterPaymentModules extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: RequestState.NONE
    };
  }

  componentDidMount() {
    this.maybeLoadPaymentInfo();
  }

  componentDidUpdate() {
    this.maybeLoadPaymentInfo();
  }

  maybeLoadPaymentInfo = () => {
    const {
      accountStore,
      countryStore,
      paymentModuleStore,
      languageIsSet
    } = this.props;

    if (paymentModuleStore.state === RequestState.NONE && languageIsSet) {
      paymentModuleStore
        .loadPaymentModules({
          countryCode: countryStore.activeCountry.id,
          groupId: accountStore.getCustomerGroupId
        })
        .then(() => {
          this.setState({
            loaded: RequestState.LOADED
          });
        })
        .catch((error) => console.error(error));
    }
  };

  getKlarnaScript = () => {
    const { paymentModuleStore } = this.props;

    if (!paymentModuleStore.widgets) {
      return null;
    }

    const klarnaWidget = paymentModuleStore.widgets.find(
      (widget) => widget.type === PaymentWidgetType.KLARNA
    );

    return klarnaWidget.script;
  };

  renderPaymentModules = () => {
    const { paymentModuleStore } = this.props;
    const imgHeight = MAX_IMAGE_HEIGHT;
    const imgWidth = Math.round(MAX_IMAGE_HEIGHT * IMAGE_ASPECT_RATIO);

    return (
      <div className="FooterPaymentModules__images">
        {paymentModuleStore.methods.map(
          (module, index) =>
            module && module.logo ? (
              <img
                key={index}
                width={imgWidth}
                height={imgHeight}
                src={module.logo}
                alt={module.name}
                loading="lazy"
                title={module.name}
                className="FooterPaymentModules__image"
              />
            ) : null
        )}
      </div>
    );
  };

  render() {
    const { paymentModuleStore, languageIsSet } = this.props;

    if (!languageIsSet) {
      return null;
    }

    return (
      <div className="FooterPaymentModules">
        {paymentModuleStore.widgets.length > 0 ? (
          <KlarnaPromotionWidget
            widgetType={'footer-promotion-auto-size'}
            paymentModuleQueryResultKey={'footer'}
            externalKlarnaScript={this.getKlarnaScript()}
          />
        ) : (
          this.renderPaymentModules()
        )}
      </div>
    );
  }
}

FooterPaymentModules.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  countryStore: modelOf(CountryStore).isRequired,
  paymentModuleStore: modelOf(PaymentModuleStore).isRequired,
  languageIsSet: PropTypes.bool
};

export default inject('accountStore', 'countryStore', 'paymentModuleStore')(
  FooterPaymentModules
);



// WEBPACK FOOTER //
// ./src/components/footer/FooterPaymentModules/index.jsx